<div [ngStyle]="{'width': width() ? width() : '100%'}" #lottieContainer></div>
